import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Task} from './task';

@Injectable()
export class TaskService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all tasks which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.taskURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(task : Task) {
    console.log('Push task to insert method of service.');
    task.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(task));
    return this.http.post(this.config.taskURL+"new", JSON.stringify(task), {headers: this.headers});
  }

  public update(task : Task) {
    console.log('Push task to update method of service.');
    task.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(task));
    return this.http.put(this.config.taskURL+"id/"+task.id, JSON.stringify(task), {headers: this.headers});
  }

  public qryTask(id : number) {
    return this.http.post(this.config.taskURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete task '+ id);
    return this.http.post(this.config.taskURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task.service.ts